<template>
  <div class="container" role="tablist">
    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="text-nowrap font-weight-bold m-0">Landing Section</h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.landing-form-1
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>

          <b-collapse
            visible
            ref="collapse"
            class="mt-3 col-12"
            id="landing-form-1"
          >
            <hr />
            <div class="">
              <b-form
                class=""
                @submit.prevent="updateData(dbRefs.homeRef, form)"
              >
                <b-form-group
                  id="input-group-1"
                  label="Main title"
                  label-for="input-1"
                  description="This is the text at the top "
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.landing.title"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="input-group-2"
                  label="Sub title"
                  label-for="input-2"
                  description="This is the text below main title "
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.landing.subtitle"
                  ></b-form-input>
                </b-form-group>

                <b-button
                  class="btn-carnival px-5 py-1"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  <span>Save</span>
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>

    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="font-weight-bold m-0 text-nowrap">Welcome Section 1</h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.welcome1
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>

          <b-collapse
            ref="collapse"
            class="mt-3 col-12"
            id="welcome1"
            accordion="home-accordion"
          >
            <hr />
            <div class="">
              <b-form
                class=""
                @submit.prevent="updateData(dbRefs.homeRef, form)"
              >
                <b-form-group
                  id="input-group-1"
                  label="From"
                  label-for="input-1"
                  description="Who is this message from ?"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.welcome1.from"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="Summary"
                  description="Welcome message summary"
                >
                  <b-form-textarea
                    id="input-2"
                    v-model="form.welcome1.summary"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group label="Message Body">
                  <b-form-textarea
                    id="input-2"
                    v-model="form.welcome1.messageBody"
                    rows="6"
                  ></b-form-textarea>
                </b-form-group>

                <b-button
                  class="btn-carnival px-5 py-1"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  Save
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="font-weight-bold m-0 text-nowrap">Welcome Section 2</h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.welcome2
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>

          <b-collapse
            ref="collapse"
            class="mt-3 col-12"
            id="welcome2"
            accordion="home-accordion"
          >
            <hr />
            <div class="">
              <b-form
                class=""
                @submit.prevent="updateData(dbRefs.homeRef, form)"
              >
                <b-form-group
                  id="input-group-1"
                  label="From"
                  label-for="input-1"
                  description="Who is this message from?"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.welcome2.from"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="Summary"
                  description="Welcome message summary"
                >
                  <b-form-textarea
                    id="input-2"
                    v-model="form.welcome2.summary"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group label="Welcome message">
                  <b-form-textarea
                    id="input-2"
                    v-model="form.welcome2.messageBody"
                    rows="6"
                  ></b-form-textarea>
                </b-form-group>

                <b-button
                  class="btn-carnival px-5 py-1 flex-row"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  Save
                  <!--<span class="d-none loader"><b-spinner style="width: 17px; height: 17px"-->
                  <!--class="ml-2"-->
                  <!--small></b-spinner></span>-->
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="font-weight-bold m-0 text-nowrap">Video Section</h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.videoSection
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>

          <b-collapse
            ref="collapse"
            class="mt-3 col-12"
            id="videoSection"
            accordion="video-section-accordion"
          >
            <hr />
            <div class="">
              <b-form
                class=""
                @submit.prevent="updateData(dbRefs.homeRef, form)"
              >
                <b-form-group
                  id="input-group-1"
                  label="Title"
                  label-for="input-1"
                  description="Video section title"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.videoSection.title"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Link" description="Provide link for video">
                  <b-form-input
                    id="input-2"
                    v-model="form.videoSection.url"
                  ></b-form-input>
                </b-form-group>

                <b-button
                  class="btn-carnival px-5 py-1 flex-row"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  Save
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="font-weight-bold m-0 text-nowrap">
              Carnival Diary Info
            </h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.diary
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>

          <b-collapse
            ref="collapse"
            class="mt-3 col-12"
            id="diary"
            accordion="diary-accordion"
          >
            <hr />
            <div class="">
              <b-form
                class=""
                @submit.prevent="updateData(dbRefs.homeRef, form)"
              >
                <b-form-group
                  id="input-group-1"
                  label="Title"
                  label-for="input-1"
                  description="Carnival diary title"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.carnivalDiary.title"
                    placeholder="Carnival Diary"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="input-group-1"
                  label="Month"
                  label-for="input-1"
                  description="Carnival diary month"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.carnivalDiary.month"
                    placeholder="July"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Year"
                  label-for="input-1"
                  description="Carnival diary year"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.carnivalDiary.year"
                    :placeholder="new Date().getFullYear()"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Date & Time"
                  label-for="input-1"
                  description="Carnival diary date and time"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.carnivalDiary.dateTime"
                    placeholder="2pm – 9:30pm 2019"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="Location"
                  description="Provide location details"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.carnivalDiary.location"
                  ></b-form-input>
                </b-form-group>

                <b-button
                  class="btn-carnival px-5 py-1 flex-row"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  Save
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from "../../eventBus";
  import { defaultHomeContent } from "../../utils/content";
  import DataStreamListener from "../../mixins/dataListener";
  import AddDataHandler from "../../mixins/genericAddDataHandler";

  export default {
    data() {
      return {
        form: { ...defaultHomeContent },
      };
    },
    mixins: [DataStreamListener, AddDataHandler],
    methods: {},
    async mounted() {
      this.fetchSingleData(this.dbRefs.homeRef, defaultHomeContent);
      EventBus.$on("dataFetched", (homeContent) => {
        this.form = homeContent;
        setTimeout(() => {
          this.fetching = false;
        }, 1000);
      });
    },
  };
</script>

<style scoped lang="scss">
  img {
    cursor: pointer;
  }

  .editing {
  }
</style>
